import React, { useCallback } from 'react';
import { getIn } from 'formik';

import { TextField } from '../../text-field';
import { FieldElementPropTypes } from '../propTypes';
import { buildTooltipAdornment } from './tooltip-adornment';

const StringField = ({
  field: {
    id,
    name,
    label,
    mode,
    value,
    optional,
    onChange: customOnChange,
    tooltipText,
    tooltipLabel,
    InputProps,
    ...props
  },
  ctx: { handleChange, touched, errors, classes, setFieldTouched, setFieldValue }
}) => {
  const onChange = useCallback(
    (e) => {
      handleChange(e);
      // Write to the Formik field `name`, not the DOM `id`. They are usually equal, but decoupling
      // them lets callers pass a unique DOM `id` (to avoid duplicate-id focus bugs, #32617) while
      // keeping the flat Formik path. Aligns with the sibling field types (textarea/select/etc.).
      setFieldValue(name || id, e.target.value);
      setFieldTouched(name || id, true, false);
      if (customOnChange) {
        customOnChange(e.target.value, id || name);
      }
    },
    [handleChange, setFieldTouched, id, customOnChange, name, setFieldValue]
  );
  const tooltipAdornment = buildTooltipAdornment(tooltipText, tooltipLabel);

  return (
    <TextField
      key={id}
      id={id}
      name={name || id}
      label={label}
      value={value || ''}
      onChange={onChange}
      error={getIn(touched, name || id) && !!getIn(errors, name || id)}
      helperText={getIn(touched, name || id) && getIn(errors, name || id)}
      mode={mode}
      fullWidth
      classes={classes[id]}
      {...props}
      InputProps={{
        ...(tooltipAdornment ? { endAdornment: tooltipAdornment } : {}),
        ...(InputProps || {})
      }}
    />
  );
};

StringField.propTypes = FieldElementPropTypes;

export default StringField;
